// cSpell:enableCompoundWords
import GameItem from 'components/tabs/gameselect/components/gameitem/GameItem';
import SectionHeader from 'components/tabs/gameselect/components/sectionheader/SectionHeader';
import useLobbyManager from 'hooks/useLobbyManager';
import React from 'react';
import styles from './GamesSection.module.scss';

type CompletedGamesSectionProps = {
  className?: string;
};

const CompletedGamesSection: React.FC<CompletedGamesSectionProps> = ({ className = '' }) => {
  const baseCls = `${styles.SectionList} ${styles.SectionListColumn} ${className}`;

  const { completedGamesList, onResumeGame } = useLobbyManager();

  return (
    <>
      {completedGamesList.length > 0 && (
        <div className={baseCls}>
          <SectionHeader />
          {completedGamesList.map((game) => {
            return <GameItem key={game.sqGameId} game={game} onGameClicked={onResumeGame} />;
          })}
        </div>
      )}
    </>
  );
};

export default CompletedGamesSection;
